export default [
  { 
    path: '/activity', 
    name: 'ActivityList', 
    component: () => import('@/views/activity/List'),
    meta: { 
      breadcrumbs: [
        { text: 'กิจกรรม', disabled: true }
      ] 
    }, 
  },
  { 
    path: '/activity/create', 
    name: 'ActivityCreate', 
    component: () => import('@/views/activity/Form'),
    meta: { 
      form_type: 'CREATE', 
      form_title: 'สร้าง',
      breadcrumbs: [
        { text: 'กิจกรรม', to: `/activity` },
        { text: `สร้างกิจกรรม` },
      ] 
    }, 
  },
  { 
    path: '/activity/:id/edit', 
    name: 'ActivityEdit', 
    component: () => import('@/views/activity/Form'),
    meta: { 
      form_type: 'EDIT', 
      form_title: 'แก้ไข',
      breadcrumbs: [
        { text: 'กิจกรรม', to: `/activity` },
        { text: `แก้ไขกิจกรรม` },
      ] 
    }, 
  },
]